import { Box } from '@material-ui/core';
import { VariableIcon } from '@timeflies/app-ui';
import React from 'react';
import { FeedbackEffectContainer } from './feedback-effect-container';
export var FeedbackEffectCondensed = function (_a) {
    var spellCategory = _a.spellCategory, variableNameList = _a.variableNameList;
    return (React.createElement(FeedbackEffectContainer, { spellCategory: spellCategory }, variableNameList.map(function (variableName) { return (React.createElement(Box, { key: variableName, display: 'inline-flex', mr: 0.5 },
        React.createElement(VariableIcon, { variableName: variableName }))); })));
};
